// 公共接口
export default {
  COMMON_GET_CLASSFICATION: '/api/common/classification/get',     // 获取详情分类

  COMMON_GET_DETAILS_GET: '/api/common/details/get',              // 查询具体的详情页内容

  COMMON_GET_BANNERS: '/api/common/getBanners',                   // 广告轮播图

  COMMON_GET_ALBUM: '/api/album/list',                            // 相册列表

  COMMON_GET_ALBUM_CHILDREN: '/api/album/children',               // 相册子集

  COMMON_SEASON_LIST: '/api/contest/training/season/list',        // 项目列表

  COMMON_CONTENT_LIST: '/api/content/list',                       // 相册内容列表

  COMMON_DISCOVER_INDEX: '/api/discover/index',                   // 发现精选-首页发现数据

  COMMON_FEEDBACK: '/api/common/feedback',                        // 用户反馈

  COMMON_GET_CHAT_GROUP: '/api/im/chatGroup/getChatGroup',        // 获取聊天室

  COMMON_GET_CHAT_GROUPCOMMON: '/api/im/chatGroup/getChatGroupCommon',   // SQ新增的获取聊天室

  COMMON_GET_FILE_STS: '/api/file/getSts',                        // 上传文件参数

  COMMON_GET_FILE_PUB_STS: '/api/file/getPubSts',                 // 上传文件公共

  COMMON_API_GET_FILE: '/api/file/getFile',                       // 获取阿里云文件

  COMMON_GET_USER_SIG: '/api/im/user/getUserSig',                 // 获取userSig

  COMMON_GET_USER_SIG_WITH_REGISTER: '/api/im/user/getUserSigWithRegister',                 // 获取userSig-ai批改

  VIDEO_CONFIG: '/api/video/config',                              // 获取视频配置信息

  VIDEO_PLAY_INFO: '/api/video/playInfo',                         // 获取视频配置信息

  PRAISE_FIND: '/api/interaction/praise/find',                    // 获取是否点赞

  WEB_PRAISE_SAVE: '/api/web/praise/save',                        // 这是点赞

  CHAT_USERS: '/api/user/chat/users',                             // 获取直播间人数

  COMMON_EXAM_TRANSACTION: '/api/exam/submitExamTransaction',     // 考试切屏

  WORK_WRITING_BLURNUM: '/api/work/writing/blurNum',     // 考试切屏

  COMMON_NOTICE_LIST: '/api/notice/getNoticeList',                // 查询公告列表

  COMMON_NOTICE_INFO: '/api/notice/getNotice',                    // 公告详情

  COMMON_NOTICE_UNREAD: '/api/notice/getUnreadNotice',            // 未读公告列表

  COMMON_NOTICE_NUM: '/api/notice/getUnreadNum',                  // 未读公告数

  COMMON_QUESTIONNAIRE_INFO: '/api/questionnaire/info',           // 通过问卷id获取问卷

  COMMON_QUESTIONNAIRE_SUBMIT: '/api/questionnaire/submit',       // 提交问卷

  REPROT_LOG_RECORD: '/api/common/reportLogRecord',               // 上报日志

  COMMON_ONLINE_LIST: '/api/video/live/online/list',              // 获取直播

  COMMON_AI_TOPIC_GET_CONFIG: '/api/v3/customer/ai/topic/get/config',             // 获取AI主题配置

  COMMON_AI_TOPIC_GENERATE: '/api/v3/customer/ai/topic/generate',             // 生成AI主题

  TRACK_EVENT_COLLECT: '/api/v3/datacenter/ets/event/collect',                                   // 埋点事件收集

  // 伴学助手接口

  DIALOGUE_LIST: '/api/v3/customer/dialogue/list',                                   // (学生端)对话历史列表

  DIALOGUE_MSGLOG: '/api/v3/customer/dialogue/msgLog',                                   // (学生端)聊天记录列表

  DIALOGUE_SEND: '/api/v3/customer/dialogue/send',                                   // (学生端)发送聊天消息

  UNSUBSCRIBE_EMAIL: '/api/v3/contest/email/unsubscribe',                                   // 取消邮件订阅

  UNSUBSCRIBE_MAIL: '/api/v3/msg/mail/unsubscribe'          // 邮件退订（oms 独立服务）
}



// WEBPACK FOOTER //
// ./src/assets/api/constant/common.js